export default "__VITE_ASSET__CdXa8yZ$__"